module.exports = __webpack_public_path__ + "img/Pack Station (WMS Module)_Page_12.7c786c4e.jpg";